import * as yup from 'yup'
import i18n from 'config/i18n'
import { SET_UP_ERRORS, ERROR_CODES } from 'state/error'
import { ERROR_MESSAGES } from './errorMessages'

export const baseValidationSchema = (isCampaignDraftOrForEdit: boolean, lastEditSlots: number) => {
    return yup.object().shape({
        brandUuid: yup.string().nullable().required(i18n.t('errorMessage.validation.selectBrand')),
        objective: yup.number().nullable().default(null),
        categories: yup
            .array()
            .max(2, i18n.t('errorMessage.validation.selectCategoryLimit'))
            .test({
                message: ERROR_MESSAGES[SET_UP_ERRORS.CATEGORIES][ERROR_CODES.INPUT_REQUIRED],
                test: (value: number[]) => {
                    if (isCampaignDraftOrForEdit) {
                        return true
                    } else {
                        return Boolean(value.length)
                    }
                },
            }),

        title: yup
            .string()
            .nullable()
            .max(100, i18n.t('errorMessage.validation.enterCampaignNameCharacterLimit'))
            .required(i18n.t('errorMessage.validation.enterCampaignName')),
        budget: yup
            .number()
            .default(null)
            .nullable()
            .min(0, i18n.t('errorMessage.validation.enterNonZeroBudget'))
            .test({
                message: ERROR_MESSAGES[SET_UP_ERRORS.BUDGET][ERROR_CODES.INPUT_REQUIRED],
                test: (value: number | null) => {
                    if (isCampaignDraftOrForEdit) {
                        return true
                    }
                    if (value === 0) {
                        return true
                    } else {
                        return Boolean(value)
                    }
                },
            }),
        slot_required: yup.boolean(),
        slot_number: yup
            .number()
            .default(null)
            .nullable()
            .min(1, ERROR_MESSAGES['slot_number'][ERROR_CODES.SLOT_NUMBER_LESS_THAN_ONE])
            .when(['slot_required'], (isRequireSlots: boolean, schema: yup.NumberSchema<number | null>) => {
                if (isCampaignDraftOrForEdit || !isRequireSlots) {
                    return schema
                }

                return schema.required(ERROR_MESSAGES['slot_number'][ERROR_CODES.INPUT_REQUIRED])
            }),
        is_private: yup.mixed().oneOf([null, true, false]),
        registration_enable: yup.boolean(),
        registration_max_slots: yup
            .number()
            .nullable()
            .when('registration_enable', {
                is: true,
                then: yup
                    .number()
                    .default(null)
                    .nullable()
                    .typeError(i18n.t('errorMessage.businessLogic.enterWholeNumber'))
                    .positive(i18n.t('errorMessage.businessLogic.enterNonZeroSlots'))
                    .test({
                        message: ERROR_MESSAGES['registration_max_slots'][ERROR_CODES.INPUT_REQUIRED],
                        test: (value: number | null) => {
                            if (isCampaignDraftOrForEdit) {
                                return true
                            }
                            if (value === 0) {
                                return true
                            } else {
                                return Boolean(value)
                            }
                        },
                    }),
            })
            .when('isCampaignLive', {
                is: true,
                then: yup
                    .number()
                    .nullable()
                    .typeError(i18n.t('errorMessage.businessLogic.enterWholeNumber'))
                    .when('registration_enable', {
                        is: true,
                        then: yup
                            .number()
                            .required(ERROR_MESSAGES['registration_max_slots'][ERROR_CODES.INPUT_REQUIRED]),
                    }),
            }),
        profile_recommendation_enabled: yup.boolean(),
        auto_update_submission_status: yup.boolean(),
        submission_status_filling_fast_min: yup
            .number()
            .nullable()
            .when('auto_update_submission_status', {
                is: true,
                then: yup
                    .number()
                    .nullable()
                    .test({
                        message:
                            ERROR_MESSAGES[SET_UP_ERRORS.SUBMISSION_STATUS_FILLING_FAST_MIN][
                                ERROR_CODES.INPUT_REQUIRED
                            ],
                        test: (value: number | null) => {
                            if (isCampaignDraftOrForEdit) {
                                return true
                            }
                            if (value === 0) {
                                return true
                            } else {
                                return Boolean(value)
                            }
                        },
                    })
                    .positive(i18n.t('errorMessage.businessLogic.enterNonZeroSlots')),
            }),
        submission_status_full_min: yup
            .number()
            .nullable()
            .when('auto_update_submission_status', {
                is: true,
                then: yup
                    .number()
                    .nullable()
                    .test({
                        message: ERROR_MESSAGES[SET_UP_ERRORS.SUBMISSION_STATUS_FULL_MIN][ERROR_CODES.INPUT_REQUIRED],
                        test: (value: number | null) => {
                            if (isCampaignDraftOrForEdit) {
                                return true
                            }
                            if (value === 0) {
                                return true
                            } else {
                                return Boolean(value)
                            }
                        },
                    })
                    .positive(i18n.t('errorMessage.businessLogic.enterNonZeroSlots')),
            })
            .when('submission_status_filling_fast_min', (submission_status_filling_fast_min: number, schema: any) =>
                submission_status_filling_fast_min
                    ? schema.min(
                          submission_status_filling_fast_min + 1,
                          i18n.t('errorMessage.businessLogic.enterHigherNumberSubmissionFull'),
                      )
                    : schema,
            ),
        batching_enable: yup.boolean().nullable(),
    })
}
